import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-home3',
  templateUrl: './home3.component.html',
  styleUrls: ['./home3.component.scss']
})
export class Home3Component implements OnInit, OnDestroy {
  ngOnInit(): void {
    document.body.classList.add('home3-page');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('home3-page');
  }
}
